module.exports = __webpack_public_path__ + "img/Jonas-Fjeld_Bilde-fra-De-dødes-tjern.280c116d.jpg";